module.exports = {"datadog":"6faa605a-f2e2-4ef6-9c9a-062871d6142c","intercom":"y160n8rf","recaptcha":"6LduWoQaAAAAANAFTGU6tgFtNYwTR-uCxVyJFaLt"};